import React, { useState } from 'react'
import { putData } from '../../../../services/library';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from '@mui/material';
import Notify from '../../../Notify';

function MarcarRendicionInactiva(props) {
 const [datos, setDatos] = useState(props.rendicion);
  const [disBtn, setDisBtn] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  const handleClose = () => {
    props.onClose(false);
  };


  async function marcarInactivo(e) {
    setDisBtn(true);
    putData(
      e,
      "/envasado_rendiciones/" + datos.id,
      {
        activo: 0,
      },
      setNotificacion
    );
  }

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => {
            //   props.actualizar();
              props.onClose(false);
              setNotificacion({ open: false });
            }}
            severity={notificacion.severity}
          />
        ) : null}
        <form onSubmit={marcarInactivo}>
          <Box backgroundColor={"#1F618D"}>
            <DialogTitle>
              <Typography color="#ffffff" fontSize={20}>
                Marcar Inactiva: {datos.nro_rendicion}
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent>
            <DialogContentText textAlign={"center"}>
              ¿Seguro que quiere marcar como inactiva la rendición?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack spacing={45} direction="row">
              <Button
                color="error"
                disabled={disBtn}
                variant="contained"
                onClick={handleClose}
              >
                Volver
              </Button>
              <Button color="success" type="submit" variant="contained"  disabled={disBtn}>
                Confirmar
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}

export default MarcarRendicionInactiva